import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services';

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss']
})
export class SuccessPageComponent implements OnInit, OnDestroy {

  private subscribeParams: Subscription;

  credits: number = 1;
  reportId: string = '';
  constructor(private router: Router,
    public commonService: CommonService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.subscribeParams = this.activatedRoute.queryParams.subscribe(resRoute => {
      this.credits = resRoute.amount ? Number(resRoute.amount) < 1 ? 1 : Number(resRoute.amount) : 1;
      this.reportId = resRoute.id ? resRoute.id : '';
    });
  }

  ngOnDestroy(): void {
    if (this.subscribeParams)
      this.subscribeParams.unsubscribe();
  }

  /**
   * @description for goto conclusion page
   */
  gotoConclusion() {
    this.router.navigateByUrl(`/report/${this.reportId}/conclusion`);    
  }

}
